"use client";

import { usePathname } from "next/navigation";
import { format, parseISO } from "date-fns";

import {
  DOCS_BASE,
  docsIndexLastModified,
  flatDocs,
} from "@/app/(marketing)/docs/_config";

/**
 * "Last updated <date>" rendered under each doc's `h1` (see the `h1`
 * override in `src/mdx-components.tsx`), sourced from the same
 * hand-maintained `lastModified` value in `_config.ts` that drives the
 * sitemap and the TechArticle `dateModified` (see docs-json-ld.ts) — one
 * date, three surfaces. See issue #1250.
 */
export function LastUpdated() {
  const pathname = usePathname();
  // The /docs hub isn't a flatDocs() entry; it uses the same freshest-page
  // date as its sitemap entry and TechArticle.
  const lastModified =
    pathname === DOCS_BASE
      ? docsIndexLastModified()
      : flatDocs().find((d) => d.path === pathname)?.lastModified;
  if (!lastModified) return null;

  return (
    <p className="text-rl-text3 -mt-1 mb-6 text-[0.8rem]">
      Last updated{" "}
      <time dateTime={lastModified}>
        {format(parseISO(lastModified), "MMMM d, yyyy")}
      </time>
    </p>
  );
}
